import Sonda from "@gcloud-npm/utils.monitoring.sonda";
import getUUID from '@gcloud-npm/utils.monitoring.get-uuid';
import Request from '@/utils/fetch';
import { calculateHeaderParams } from '@gcloud-npm/node.build-process.build-environments';
import { FAMILY_API } from '@gcloud-npm/utils.enums.environment';
import {
  makeUpTelcoPathName,
  getAdabyronConstants,
  PROCESS_NAME,
} from "@gcloud-npm/utils.adabyron.make-up-telco-path-name";
import sendToRelogin from '@gcloud-npm/utils.page.send-to-relogin';

const PATH = 'consumos/misconsumos/detallado';
const EVENT_NAME = 'USAGES.GET_DETAILED_USAGE';
const METHOD = 'GET';

export const getDetailedUsage = ({
  data,
  context,
  idFront = 'TC',
  build = false,
  version,
  onRedirect,
}) => {
  const { mode, productIds, period, useType, pageNumber, month } = data;
  const { environment, userType } = context;
  const { telco: connectionData } = environment;
  const { endpoint: host } = connectionData;
  const idRequest = getUUID(idFront);
  const { prefixToApply } = getAdabyronConstants(userType);
  const headers2Use = calculateHeaderParams(build, FAMILY_API.TELCO, context);

  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME.CLIENT,
  });

  const queryParams = [];
  queryParams.push({ param: 'productIds', value: Array.isArray(productIds) ? productIds.join() : productIds });
  queryParams.push({ param: 'modo', value: mode });
  queryParams.push({ param: 'periodo', value: period });
  queryParams.push({ param: 'tipoUso', value: useType });
  queryParams.push({ param: 'pageNumber', value: pageNumber });
  queryParams.push({ param: 'month', value: month ? month : 0 });

  const urlParamsToReplace = [];

  const URL_API = makeUpTelcoPathName({
    path: PATH,
    version,
    idRequest,
    host,
    prefixToApply,
    queryParams,
    urlParamsToReplace,
  });

  const request = new Request({
    method: METHOD,
    endpoint: URL_API,
    headers: headers2Use,
    sonda,
    onRedirect: onRedirect || sendToRelogin,
  });
  return request.makeRequest();
};

export default getDetailedUsage;
